/**
 * Associations step body for CreateObjectTypeWizard — the notes toggle plus
 * the inline association editor. Extracted from CreateObjectTypeWizard.tsx
 * to keep that file within the project's file-size convention.
 */

import { memo } from 'react';

import { Checkbox } from '@/lib/base/forms/checkbox';
import { useWizardContext } from '@/lib/base/wizard';

import {
  type AssociationDefinition,
  InlineAssociationEditor,
} from '../../InlineAssociationEditor';

export interface AssociationsStepProps {
  pluralName: string;
  notesEnabled: boolean;
  onNotesEnabledChange: (enabled: boolean) => void;
  associations: AssociationDefinition[];
  onAssociationsChange: (assocs: AssociationDefinition[]) => void;
  generatedTypeName: string;
  orgId: number;
}

function AssociationsStepBodyImpl({
  pluralName,
  notesEnabled,
  onNotesEnabledChange,
  associations,
  onAssociationsChange,
  generatedTypeName,
  orgId,
}: AssociationsStepProps) {
  const { isSubmitting } = useWizardContext();
  return (
    <div className='space-y-4'>
      <Checkbox
        isSelected={notesEnabled}
        onChange={onNotesEnabledChange}
        isDisabled={isSubmitting}
        label='Enable notes'
        hint={`Allow attaching notes to ${pluralName.trim().toLowerCase() || 'these objects'}`}
      />

      <InlineAssociationEditor
        associations={associations}
        onChange={onAssociationsChange}
        disabled={isSubmitting}
        orgId={orgId}
        sourceEntityTypeName={generatedTypeName}
        sourcePluralName={pluralName.trim() || undefined}
      />
    </div>
  );
}

export const AssociationsStepBody = memo(AssociationsStepBodyImpl);
